<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >在线文档</span>
      <!-- <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >测试工具</span> -->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'order/addOrder';
export default {
  components: { onlineDoc , apiTestDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: "与平台签约的客户，可通过此接口创建/修改订单。目前创建订单接口支持修改订单，即如果客户订单号（txlogisticId）已存在，且对应的订单未揽件，则直接修改已有订单。如果收件地址发生变更就重新获取最新的三段码/大头笔返回（运单号不变）；",
      //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
         //参数描述  START
       postDataList:[

        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: "接入方在平台的api账户标识",},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: "签名字符串",},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: "时间戳，毫秒",},
                    ]
            },
            {
                title:'请求参数',
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
            {
              title:"业务参数",
              value:[
                {name: "customerCode",type: "String(30)",require: "Y",normal: "J0086474299",describe: "客户编码（联系出货网点提供）"},
                {name: "digest",type: "String(50)",require: "Y",normal: "明文密码:H5CD3zE6",describe: "签名，Base64(Md5(客户编号+密文+privateKey))，其中密文：MD5(明文密码+jadada236t2) 后大写"},
                {name: "network",type: "String(30)",require: "N",normal: "",describe: "合作网点编码（没有则不传）"},
                {name: "txlogisticId",type: "String(50)",require: "Y",normal: "",describe: "客户订单号（传客户自己系统的订单号）"},
                {name: "expressType",type: "String(30)",require: "Y",normal: "",describe: "快件类型：<br />EZ(标准快递)<br />TYD(兔优达)"},
                {name: "orderType",type: "String(11)",require: "Y",normal: "",describe: "订单类型（有客户编号为月结）1、 散客；2、月结；"},
                {name: "serviceType",type: "String(30)",require: "Y",normal: "",describe: "服务类型 ：02 门店寄件 ； 01 上门取件"},
                {name: "deliveryType",type: "String(30)",require: "Y",normal: "",describe: "派送类型： 06 代收点自提  05 快递柜自提  04 站点自提  03 派送上门"},
                {name: "payType",type: "String(30)",require: "Y",normal: "",describe: `支付方式：PP_PM("寄付月结")`},
                {name: "sender",type: "Object",require: "Y",normal: "",describe: "寄件信息对象"},
                {name: "receiver",type: "Object",require: "Y",normal: "",describe: "收件信息对象"},
                {name: "sendStartTime",type: "String(30)",require: "N",normal: "",describe: "物流公司上门取货开始时间 yyyy-MM-dd HH:mm:ss"},
                {name: "sendEndTime",type: "String(30)",require: "N",normal: "",describe: "客户物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss"},
                {name: "goodsType",type: "String(30)",require: "Y",normal: "",describe: "物品类型（对应订单主表物品类型）:<p>bm000001 文件</p>  <p>bm000002 数码产品</p>  <p>bm000003 生活用品</p>  <p>bm000004  食品</p>  <p>bm000005  服饰</p>  <p>bm000006  其他</p>  <p>bm000007 生鲜类</p>  <p>bm000008 易碎品</p><p>bm000009 液体</p>"},
                {name: "isRealName",type: "Boolean",require: "N",normal: "",describe: "是否实名"},
                {name: "isCustomsDeclaration",type: "Boolean",require: "N",normal: "",describe: "是否申报海关"},
                {name: "length",type: "int(6)",require: "N",normal: "",describe: "长，cm编号"},
                {name: "width",type: "int(6)",require: "N",normal: "",describe: "宽，cm"},
                {name: "height",type: "int(6)",require: "N",normal: "",describe: "高，cm"},
                {name: "weight",type: "String(12)",require: "Y",normal: "默认0.02",describe: "重量，单位kg，范围0.01-50"},
                {name: "totalQuantity",type: "int(4)",require: "N",normal: "",describe: "包裹总票数(必须为1)"},
                {name: "itemsValue",type: "String(12)",require: "N",normal: "",describe: "代收货款金额 (数值型)"},
                {name: "priceCurrency",type: "String(32)",require: "N",normal: "",describe: "代收货款币别（默认本国币别，如：RMB）"},
                {name: "offerFee",type: "String(12)",require: "N",normal: "",describe: "保价金额(数值型)，单位：元"},
                {name: "remark",type: "String(200)",require: "N",normal: "",describe: "备注"},
                {name: "items",type: "Object",require: "N",normal: "",describe: "商品信息列表"},
                {name: "customsInfo",type: "Object",require: "N",normal: "",describe: "客户信息"},
                {name: "postSiteCode",type: "String(20)",require: "N",normal: "",describe: "驿站编码"},
                {name: "postSiteName",type: "String(100)",require: "N",normal: "",describe: "驿站名称"},
                {name: "postSiteAddress",type: "String(200)",require: "N",normal: "",describe: "驿站地址"},
                {name: "pickupExpressCodeCheckWay",type: "int",require: "N",normal: "",describe: "是否校验取件：对接前，请与对接人确认是否支持。<br />0-不需要校验，1-需要校验"},
                {name: "pickUpCode",type: "String(50)",require: "N",normal: "",describe: "取件码：当pickupExpressCodeCheckWay为1时必传，非1时过滤取件码。"},
                {name: "extendInfo",type: "Map<String, String>",require: "N",normal: "{\n" +
                    " \"isFourLevelAddress\": \"1\" //1：是 0：否\n" +
                    " }",describe: "拓展字段，用于特殊场景下的标识下发"},
              ]
            },
            {
              title:"sender类型说明",
              value:[
                {name: "name",type: "String(32)",require: "Y",normal: "",describe: "寄件人姓名"},
                {name: "company",type: "String(100)",require: "N",normal: "",describe: "寄件公司"},
                {name: "postCode",type: "String(32)",require: "N",normal: "",describe: "寄件邮编"},
                {name: "mailBox",type: "String(150)",require: "N",normal: "",describe: "寄件邮箱"},
                {name: "mobile",type: "String(30)",require: "Y",normal: "",describe: "寄件手机（手机和电话二选一必填）"},
                {name: "phone",type: "String(30)",require: "Y",normal: "",describe: "寄件电话（手机和电话二选一必填）"},
                {name: "countryCode",type: "String(20)",require: "Y",normal: "",describe: "寄件国家三字码（如：中国=CHN、印尼=IDN）"},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe: "寄件省份"},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe: "寄件城市"},
                {name: "area",type: "String(32)",require: "Y",normal: "",describe: "寄件区域"},
                {name: "town",type: "String(32)",require: "N",normal: "",describe: "寄件乡镇"},
                {name: "street",type: "String(32)",require: "N",normal: "",describe: "寄件街道"},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe: "寄件详细地址（省+市+区县+详细地址）"}
              ]
            },
            {
              title:"receiver类型说明",
              value:[
                {name: "name",type: "String(32)",require: "Y",normal: "",describe: "收件人姓名"},
                {name: "company",type: "String(100)",require: "N",normal: "",describe: "收件公司"},
                {name: "postCode",type: "String(32)",require: "N",normal: "",describe: "收件邮编"},
                {name: "mailBox",type: "String(150)",require: "N",normal: "",describe: "收件邮箱"},
                {name: "mobile",type: "String(30)",require: "Y",normal: "",describe: "收件手机（手机和电话二选一必填）"},
                {name: "phone",type: "String(30)",require: "Y",normal: "",describe: "收件电话（手机和电话二选一必填）"},
                {name: "countryCode",type: "String(20)",require: "Y",normal: "",describe: "收件国家三字码（如：中国=CHN、印尼=IDN）"},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe: "收件省份"},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe: "收件城市"},
                {name: "area",type: "String(32)",require: "Y",normal: "",describe: "收件区域"},
                {name: "town",type: "String(32)",require: "N",normal: "",describe: "收件乡镇"},
                {name: "street",type: "String(32)",require: "N",normal: "",describe: "收件街道"},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe: "收件详细地址（省+市+区县+详细地址）"}
              ]
            },
            {
              title:"items类型说明",
              value:[
                {name: "itemType",type: "String(30)",require: "N",normal: "",describe: "物品类型: <p>bm000001 文件</p>  <p>bm000002 数码产品</p>  <p>bm000003 生活用品</p>  <p>bm000004  食品</p>  <p>bm000005  服饰</p>  <p>bm000006  其他</p>  <p>bm000007 生鲜类</p>  <p>bm000008 易碎品</p><p>bm000009 液体</p>"},
                {name: "itemName",type: "String(30)",require: "N",normal: "",describe: "物品名称"},
                {name: "chineseName",type: "String(60)",require: "N",normal: "",describe: "物品中文名称"},
                {name: "englishName",type: "String(60)",require: "N",normal: "",describe: "物品英文名称"},
                {name: "number",type: "int(4)",require: "N",normal: "",describe: "件数，≤1"},
                {name: "itemValue",type: "String(20)",require: "N",normal: "",describe: "申报价值(数值型)"},
                {name: "priceCurrency",type: "String(20)",require: "N",normal: "",describe: "申报货款币别（默认本国币别，如：RMB）"},
                {name: "desc",type: "String(100)",require: "N",normal: "",describe: "物品描述"},
                {name: "itemUrl",type: "String(100)",require: "N",normal: "",describe: "商品URL"}
              ]
            },
            {
              title:"customsInfo类型说明",
              value:[
                {name: "count",type: "Number(5)",require: "N",normal: "",describe: "货物数量 跨境件报关需要填写"},
                {name: "unit",type: "String(30)",require: "N",normal: "",describe: "货物单位，如：个、台、本， 跨境件报关需要填写"},
                {name: "sourceArea",type: "String(5)",require: "N",normal: "",describe: "原产地国别， 跨境件报关需要填写"},
                {name: "productRecordNo",type: "String(18)",require: "N",normal: "",describe: "货物产品国检备案编号 跨境件报关需要填写"},
                {name: "goodPrepardNo",type: "String(100)",require: "N",normal: "",describe: "商品海关备案号 跨境件报关需要填写"},
                {name: "taxNo",type: "String(100)",require: "N",normal: "",describe: "商品行邮税号 跨境件报关需要填写"},
                {name: "hsCode",type: "String(100)",require: "N",normal: "",describe: "海关编码 跨境件报关需要填写"},
                {name: "goodsCode",type: "String(60)",require: "N",normal: "",describe: "商品编号 跨境件报关需要填写"},
                {name: "brand",type: "String(60)",require: "N",normal: "",describe: "货物品牌 跨境件报关需要填写"},
                {name: "specifications",type: "String(60)",require: "N",normal: "",describe: "货物规格型号 跨境件报关需要填写"},
                {name: "manufacturer",type: "String(100)",require: "N",normal: "",describe: "生产厂家 跨境件报关需要填写"},
                {name: "cargoDeclaredValue",type: "Double (16,5)",require: "N",normal: "",describe: "托寄物声明价值 跨境件报关需要填写"},
                {name: "declaredValueDeclaredCurrency",type: "String(5)",require: "N",normal: "",describe: "托寄物声明价值币别 跨境件报关需要填写"},
                {name: "customerFreight",type: "String(100)",require: "N",normal: "",describe: "客户支付的运费 跨境件报关需要填写"},
                {name: "iePort",type: "String(4)",require: "N",normal: "",describe: "进出口岸代码"},
                {name: "enterpriseCustomsCode",type: "String(10)",require: "N",normal: "",describe: "电商企业的海关注册登记编号，固定 10 位长度。"},
              ]
            }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[

        //   响应参数
            {
                title:'响应参数',
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: "返回码，见附录"},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: "描述"},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: "业务数据"},
                  ]
            },
            {
              title:"data类型说明",
              value:[
                  {name: "lastCenterName",type: "String",require: "Y",normal: "",describe: "集包地"},
                  {name: "txlogisticId",type: "String",require: "Y",normal: "",describe: "返回客户订单号"},
                  {name: "createOrderTime",type: "String",require: "Y",normal: "",describe: "订单创建时间 yyyy-MM-dd HH:mm:ss"},
                  {name: "billCode",type: "String",require: "Y",normal: "",describe: "运单号"},
                  {name: "sortingCode",type: "String",require: "Y",normal: "",describe: "三段码（获取到三段码优先返回三段码，无三段码返回大头笔）"},
                  {name: "sumFreight",type: "String",require: "N",normal: "",describe: "参考总运费（数值型）"}
                ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent={"customerCode":"J0086474299","digest":"qonqb4O1eNr6VCWS07Ieeg==","network":null,"txlogisticId":"TEST20220704210006","expressType":"EZ","orderType":"1","serviceType":"01","deliveryType":"06","payType":"PP_PM","sender":{"name":"小九","company":null,"postCode":null,"mailBox":null,"mobile":"15546168286","phone":"","countryCode":"CHN","prov":"上海","city":"上海市","area":"青浦区","town":null,"street":null,"address":"庆丰三路28号"},"receiver":{"name":"田丽","company":null,"postCode":null,"mailBox":null,"mobile":"13766245825","phone":"","countryCode":"CHN","prov":"上海","city":"上海市","area":"嘉定区","town":null,"street":null,"address":"站前西路永利酒店斜对面童装店"},"sendStartTime":"2022-07-04 09:00:00","sendEndTime":"2022-07-04 18:00:00","goodsType":"bm000006","length":0,"width":0,"height":0,"weight":"0.02","totalQuantity":0,"itemsValue":null,"priceCurrency":null,"offerFee":null,"remark":null,"items":[{"itemType":null,"itemName":"衣帽鞋服","chineseName":null,"englishName":null,"number":1,"itemValue":null,"priceCurrency":"RMB","desc":null,"itemUrl":null}],"customsInfo":null,"postSiteCode":null,"postSiteName":null,"postSiteAddress":null,"realName":null, "extendInfo": {  "isFourLevelAddress": "1" }}`,
        //返回示例
        responseCode: JSON.parse(
          `{
  "code": "1",
  "msg": "success",
  "data": {
    "txlogisticId": "TEST20220704210006",
    "billCode": "UT0000498364212",
    "sortingCode": "382  300-64  010",
    "sumFreight": "5.00",
    "createOrderTime": "2022-07-04 12:00:53",
    "lastCenterName": "华东转运中心B1"
  }
}`
        ),


        //错误代码提示
        errcodeJson: [
          {code:'145003031',msg:"业务参数签名失败"},
          {code:'145002002',msg:"运单重复,请勿使用相同运单号！"},{code:'145003042',msg:"修改订单失败"},{code:'145003111',msg:"批次号无效！"},
        {code:'145003060',msg:"区域不合法"},{code:'145003061',msg:"城市不合法"},{code:'145003062',msg:"省份不合法"},
        {code:'145003064',msg:"查不到数据"},{code:'145003041',msg:"下单失败"},{code:'145003083',msg:"发件人信息不全"},
        {code:'145003112',msg:"该批次号运单无效！"},{code:'145002001',msg:"订单重复,无需重复下单！"},{code:'145003084',msg:"收件人信息不全"},
        {code:'145003085',msg:"电话号码不能为空"},{code:'145003086',msg:"地址信息不全"},{code:'145003087',msg:"请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法"},
        {code:'145003200',msg:"请检查服务类型是否合法值为 01或 02"},{code:'145003088',msg:"上门服务时间信息不全"},{code:'145003092',msg:"重量信息不合法"},
        {code:'145003093',msg:"物品信息不全"},{code:'145003094',msg:"物品名称不全"},{code:'145003095',msg:"物品类型不全"},
        {code:'145003096',msg:"物品数量非法"},{code:'145003099',msg:"非法金额"},{code:'145003100',msg:"运单号非法"},
        {code:'145003101',msg:"客户订单号已存在,无法下单！"},{code:'145003103',msg:"姓名信息非法"},{code:'145003104',msg:"公司信息过长"},
        {code:'145003105',msg:"联系信息过长"},{code:'145003106',msg:"邮编或邮箱信息非法"},{code:'145003107',msg:"价格信息非法"},
        {code:'145003108',msg:"备注、描述、链接信息非法"},{code:'145003109',msg:"地址信息过长"},{code:'145003110',msg:"街道信息过长"},
        {code:'145003111',msg:"包裹总件数无效"},{code:'145003112',msg:"暂未开通代收货款业务"},{code:'145003113',msg:"支付方式不匹配,PP_CASH,PP_MM"},
        {code:'145003201',msg:"已取件状态不可修改"},{code:'145003202',msg:"已取消状态不可修改"},{code:'145003203',msg:"更新订单失败，请稍后重试！"},
        {code:'145003083',msg:"始发地信息不全"},{code:'145003084',msg:"收货地信息不全"},
        {code:'145003340',msg:"驿站编码只能英文与数字"},{code:'145003341',msg:"驿站编码最长20字符"},
        {code:'145003342',msg:"驿站名称最长100字符"},{code:'145003343',msg:"驿站地址最长200字符"}
        ]
      },

      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{"customerCode":"J0086000020","digest":"/bGMxZbpzAtLrplAvEYvqw==","serviceType":"02","countryCode":"CHN","orderType":"2","receiver":{"area":"鼓楼区","address":"南京大学","town":"鼓楼镇","city":"南京市","mobile":"12345678909","mailBox":"ant_li123@qq.com","phone":"075587654321","countryCode":"CHN","street":"大学路","name":"中露姐1","company":"上海天美工作室","postCode":"518000","prov":"江苏省"},"expressType":"EZ","deliveryType":"03","length":30,"sendStartTime":"2020-01-18 15:05:47","weight":20,"remark":"YD9945874130030","txlogisticId":"YL101010101011","goodsType":"bm000001","volume":210,"priceCurrency":"RMB","totalQuantity":6,"sender":{"area":"雨花台区","address":"高新技术产业园","town":"粤海街道","city":"南京市","mobile":"12345678909","mailBox":"ant_li@qq.com","phone":"075512345678","countryCode":"CHN","street":"高新南七道","name":"小露姐1","company":"深圳天丑工作室","postCode":"518000","prov":"江苏省"},"itemsValue":"2000","width":10,"offerFee":1000,"items":[{"englishName":"文件111","number":30,"itemType":"bm000001","itemName":"文件222","priceCurrency":"RMB","itemValue":"2000","chineseName":"文件333","itemUrl":"http://www.baidu.com/#h%?a=10&b=20","desc":"文件"},{"englishName":"文件444","number":50,"itemType":"bm000001","itemName":"文件555","priceCurrency":"RMB","itemValue":"3000","chineseName":"文件666","itemUrl":"http://www.baidu.com/#h%?a=10&b=20","desc":"文件000"}],"sendEndTime":"2020-01-19 15:05:47","height":600}`
             },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,


        //错误代码提示
        errcodeJson: [
          {code:'145003031',msg:"业务参数签名失败"},
          {code:'145002002',msg:"运单重复,请勿使用相同运单号！"},{code:'145003042',msg:"修改订单失败"},{code:'145003111',msg:"批次号无效！"},
        {code:'145003060',msg:"区域不合法"},{code:'145003061',msg:"城市不合法"},{code:'145003062',msg:"省份不合法"},
        {code:'145003064',msg:"查不到数据"},{code:'145003041',msg:"下单失败"},{code:'145003083',msg:"发件人信息不全"},
        {code:'145003112',msg:"该批次号运单无效！"},{code:'145002001',msg:"订单重复,无需重复下单！"},{code:'145003084',msg:"收件人信息不全"},
        {code:'145003085',msg:"电话号码不能为空"},{code:'145003086',msg:"地址信息不全"},{code:'145003087',msg:"请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法"},
        {code:'145003200',msg:"请检查服务类型是否合法值为 01或 02"},{code:'145003088',msg:"上门服务时间信息不全"},{code:'145003092',msg:"重量信息不合法"},
        {code:'145003093',msg:"物品信息不全"},{code:'145003094',msg:"物品名称不全"},{code:'145003095',msg:"物品类型不全"},
        {code:'145003096',msg:"物品数量非法"},{code:'145003099',msg:"非法金额"},{code:'145003100',msg:"运单号非法"},
        {code:'145003101',msg:"客户订单号已存在,无法下单！"},{code:'145003103',msg:"姓名信息非法"},{code:'145003104',msg:"公司信息过长"},
        {code:'145003105',msg:"联系信息过长"},{code:'145003106',msg:"邮编或邮箱信息非法"},{code:'145003107',msg:"价格信息非法"},
        {code:'145003108',msg:"备注、描述、链接信息非法"},{code:'145003109',msg:"地址信息过长"},{code:'145003110',msg:"街道信息过长"},
        {code:'145003111',msg:"包裹总件数无效"},{code:'145003112',msg:"暂未开通代收货款业务"},{code:'145003113',msg:"支付方式不匹配,PP_CASH,PP_MM"},
        {code:'145003201',msg:"已取件状态不可修改"},{code:'145003202',msg:"已取消状态不可修改"},{code:'145003203',msg:"更新订单失败，请稍后重试！"},
        {code:'145003083',msg:"始发地信息不全"},{code:'145003084',msg:"收货地信息不全"},
        {code:'145003340',msg:"驿站编码只能英文与数字"},{code:'145003341',msg:"驿站编码最长20字符"},
        {code:'145003342',msg:"驿站名称最长100字符"},{code:'145003343',msg:"驿站地址最长200字符"}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
